<template>
  <v-sheet class="pa-4 h-100">
    <v-sheet outlined class="rounded overflow-hidden h-100 d-flex flex-column">
      <div
        class="pa-2 d-flex align-center justify-space-between"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <h3>Permissions Management</h3>
        <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
        <v-sheet :width="$vuetify.breakpoint.xs ? '100%' : 250">
          <v-text-field
            hide-details
            outlined
            v-if="false"
            v-model="options.search"
            dense
            class="search-bar"
            placeholder="Search..."
            clearable
            prepend-inner-icon="mdi-magnify"></v-text-field>
        </v-sheet>
      </div>
      
      <div class="flex-grow-1 h-100">
        <div class="pa-4 h-100">
          <PermissionsTree :companyId="currentCompanyId" />
        </div>
      </div>
    </v-sheet>
  </v-sheet>
</template>

<script>
import permissions from '@Share/config/permissions';
import { $has } from '@/utils';
import PermissionsTree from '@Role/components/PermissionsTree.vue';

export default {
    name: 'management-role-list',
    props: ['companyId', 'company'],
    data() {
      return {
        permissions,
        options: {
          search: '',
        },
      };
    },
    computed: {
      currentCompanyId() {
        return this.companyId || (this.company ? this.company.id : null);
      },
    },
    methods: {
      $has,
    },
    watch: {
      currentCompanyId: {
        immediate: true,
        handler() {
          // No action needed as PermissionsTree handles its own data fetching
        },
      },
    },
    components: {
      PermissionsTree,
    },
  };
</script>
